import PropTypes from 'prop-types';

import Link from 'core/components/Link';
import Social from 'core/components/Social';
import Text from 'core/components/Text';

import CaptionGroup from '../Wrappers/CaptionGroup';

import styles from './index.styl';


function Contacts(props, context) {
  const {
    phone,
    phone_additional_code: phoneAdditionalCode,
    email,
    blocks,
  } = props;

  const { socials } = context;

  /* удаляем пробелы/дефисы/скобоки, для корректного задания атрибута href="tel:+7..." */
  const phoneFormatted = phone && phone.replace(/[^\d+]+/g, '');

  return (
    <div className='contacts'>
      <style jsx>{`
        .${styles.details}
        .${styles.adress}
          margin 30px 0

          & + &
            :global(.mobile) &
              margin-top 20px
      `}</style>
      <div className={styles.details}>
        {phone && (
          <Text>
            <Link to={`tel:${phoneFormatted}`}>
              {phone}
            </Link> {phoneAdditionalCode && `(доб. ${phoneAdditionalCode})`}
          </Text>
        )}

        {email && (
          <Text>
            <Link to={`mailto:${email}`}>{email}</Link>
          </Text>
        )}

        {socials && <Social />}
      </div>

      <div className={styles.adress}>
        {blocks.map(([title, text], index) => {
          if (!title && !text) return null;

          return (
            <div className={styles.captionWrapper} key={index}>
              <CaptionGroup
                columns={blocks.length}
                key={index}
                title={title}
                content={text}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

Contacts.contextTypes = {
  socials: PropTypes.array,
};

Contacts.propTypes = {
  phone: PropTypes.string,
  phone_additional_code: PropTypes.string,
  email: PropTypes.string,
  blocks: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.string)
  ),
};

export default Contacts;
